/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { reset } from 'redux-form';
import { getCostAction, sendCostAction, setCostAction } from './actions';
import { getIsModalShownSelector, getIsFormSendingSelector, getIsCostLoadingSelector } from './selectors';
import { FORM_NAME } from './constants';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import { useInjectSaga } from '../../utils/injectSaga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import saga from './saga';
import { removeModalQuery } from '../../utils/removeModalQuery';

import closeModal from '../../utils/closeModal';
import { CostForm } from './cost-form';

const CostModalWrapper = ({
	onGetCost,
	isModalShown,
	onSendCost,
	onResetForm,
	isFormLoading,
	isFormSending,
	onSetCost,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'costModalSaga', saga });
	useInjectReducer({ key: 'costModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (isModalShown) {
			onGetCost(query.get('id'));
		}
	}, [isModalShown]);

	const handleModalCancel = () => {
		query.set('modal', 'reqs_details');
		onResetForm(FORM_NAME);
		onSetCost(null);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		onResetForm(FORM_NAME);
		onSetCost(null);
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		onSendCost({
			redirect: handleModalCancel,
			id: query.get('id'),
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Изменить заявленную стоимость груза"
			modalContent={<CostForm />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'cost' }]}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Сохранить',
							color: 'success',
							loading: isFormSending,
							disabled: isFormSending || isFormLoading,
						},
						{
							onClick: handleModalCancel,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isFormSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isModalShown: getIsModalShownSelector(),
	isFormLoading: getIsCostLoadingSelector(),
	isFormSending: getIsFormSendingSelector(),
});

const mapDispatchToProps = {
	onGetCost: getCostAction,
	onSendCost: sendCostAction,
	onResetForm: reset,
	onSetCost: setCostAction,
};

const CostModal = connect(mapStateToProps, mapDispatchToProps)(CostModalWrapper);

CostModalWrapper.propTypes = {
	onGetCost: PropTypes.func.isRequired,
	onSendCost: PropTypes.func.isRequired,
	isFormLoading: PropTypes.bool.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	onResetForm: PropTypes.func.isRequired,
	onSetCost: PropTypes.func.isRequired,
};

export default CostModal;
